/**
 * src/lib/fundsAdmin.js — đọc/ghi nguồn vốn trên Firestore cho /admin/nguon-von.
 * Document ID = fundId (giống scripts/seed-funds.mjs).
 */
import { layDb } from './firebase.js';
import { FUNDS_GOC } from '../data/funds.js';
import { chuanHoaQuy, KHOA_QUY } from './fundModel.js';

const COL = 'funds';

async function fs() {
  const db = await layDb();
  if (!db) throw new Error('Website chưa cấu hình Firebase.');
  return { db, sdk: await import('firebase/firestore/lite') };
}

export async function docTatCaQuy() {
  const { db, sdk } = await fs();
  const snap = await sdk.getDocs(sdk.collection(db, COL));
  return snap.docs.map((d) => {
    const raw = d.data();
    return chuanHoaQuy({ ...raw, fundId: raw.fundId || d.id, slug: raw.slug || d.id });
  });
}

export async function luuQuy(raw, status, email = '') {
  const { db, sdk } = await fs();
  const f = chuanHoaQuy({ ...raw, publish: { status } });
  if (!f.fundId) throw new Error('Thiếu mã quỹ.');
  const data = { ...f, updatedAt: new Date().toISOString(), updatedBy: email };
  for (const k of Object.keys(data)) if (!KHOA_QUY.includes(k)) delete data[k];
  await sdk.setDoc(sdk.doc(db, COL, f.fundId), data);
  return data;
}

export async function xoaQuy(fundId) {
  const { db, sdk } = await fs();
  await sdk.deleteDoc(sdk.doc(db, COL, fundId));
}

/** Chép quỹ có sẵn trong code lên Firestore. KHÔNG ghi đè bản đã có. */
export async function nhapQuyTuCode(daCo, email = '') {
  const thieu = FUNDS_GOC.filter((f) => !f.isExample && !daCo.includes(f.fundId));
  for (const f of thieu) await luuQuy(f, f.publish?.status || 'PUBLISHED', email);
  return thieu.length;
}
